module.exports = __webpack_public_path__ + "static/img/industrial-1636388.924810f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industrial-1636388.png
// module id = J3st
// module chunks = 1